import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Check, ExclamationCircle, InfoCircle, XCircle } from 'react-bootstrap-icons';
import axios from "axios";
import { Route, Switch } from 'react-router-dom';
import MainPage from "./components/MainPage";
import Header from "./common/Header/Header";
import ProductsPage from "./components/Products";
import SupportContactPage from "./components/SupportContactPage";
import SignUpPage from "./components/SignUpPage";
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
    const user = useSelector((state) => state.user);
    
    return (
        <main className="main-wrapper">
            <Header />
            <Switch>
                <Route exact path="/" ><MainPage /></Route>
                <Route exact path="/products" ><ProductsPage /></Route>
                <Route exact path="/contact" ><SupportContactPage /></Route>
                <Route exact path="/sign-up" ><SignUpPage /></Route>
                <Route exact path="/privacy-policy"><PrivacyPolicy /></Route>
            </Switch>
            <footer className="footer">
                <p>&copy; 2025 CRM Panel. All rights reserved.</p>
            </footer>
        </main>
    );
}

export default App;
